import axios from 'axios'

const searchApiUrl = "/api/search"
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const keysStr = urlParams.get('keys')

const searchResultEl = jQuery('#search_result_box')
const searchLoadMoreBtn = jQuery('#search_load_more_btn')
const searchLoadMoreLoader = jQuery('#search_load_more_loader')
const searchForm = jQuery('#search_page_search_form')
const searchFormInput = jQuery('#search_page_search_form_input')
const searchResultCountNumEl = jQuery('#search_result_count_num')


function newsTeaserTemplate(url, img, title, read_more) {

    return `
        <article class="news-teaser-search search-result--item">
          <div class="news-teaser-search--col image-col">
            <div class="news-teaser-search--image-box">
                <div class="news-teaser-search--image">
                    <img class="" src="${img}" alt="${title}">
                </div>
            </div>
          </div>
          <div class="news-teaser-search--col text-col">
            <h3 class="news-teaser--title text-tag text_white">${title}</h3>
            <a class="news-teaser--link text-link card-cta-link text_rockstar_gold text-link" href="${url}">${read_more} +</a>
          </div>
       </article>
    `
}

function ambassadorTeaserTemplate(url, img, title, read_more) {

    return `
       <article class="ambassador-teaser-search search-result--item">
          <div class="ambassador-teaser-search--col image-col">
            <div class="ambassador-teaser-search--image-box">
                <div class="ambassador-teaser-search--image">
                    <img class="" src="${img}" alt="${title}">
                </div>
            </div>
          </div>
          <div class="ambassador-teaser-search--col text-col">
            <h3 class="news-teaser--title text-tag text_white">${title}</h3>
            <a class="news-teaser--link text-link card-cta-link text_rockstar_gold text-link" href="${url}">${read_more} +</a>
          </div>
       </article>
    `
}


function productTeaserTemplate(url, img, title, read_more, starImage) {

    return `
        <article class="product-teaser-search search-result--item" >
            <div class="product-teaser-search--col image-col">
                <div class="product-teaser__packshot-box-wrap">
                    <div class="product-teaser__packshot-box">
                        <div class="product-teaser__packshot">
                            <img src="${img}" alt="${title}">
                        </div>
                    </div>
                </div>
            </div>
            <div class="product-teaser-search--col text-col">
                <div class="product-teaser__link">
                    <div class="product-teaser__link-inner">
                        <h3 class="product-teaser-search--title text-tag">${title}</h3>
                        <a href="${url}" class="news-teaser--link text-link card-cta-link text_rockstar_gold text-link">${read_more} +</a>
                    </div>
                </div>
            </div>
        </article>
    `
}


let state = {
    is_loading: false,
    keys: keysStr,
    page: 1,
    posts_per_page: 3,
    total_posts: 0
}


function setLoading(isLoading) {
    state.is_loading = isLoading

    if (isLoading) {
        searchLoadMoreLoader.show()
        searchLoadMoreBtn.hide()
    } else {
        searchLoadMoreLoader.hide()
        searchLoadMoreBtn.show()

    }
}

function setKeys(str) {
    state.keys = str
}

function setPage(page) {
    state.page = page
}


function setPostPerPage(postCount) {
    state.posts_per_page = postCount
}

function setTotalPost(postCount) {
    state.total_posts = postCount
}

function setSearchVelue(val) {
    searchFormInput.val(val)
}

function addPosts(postList) {
    const lastScrollHeight = window.scrollY;

    searchResultCountNumEl.text(state.total_posts)


    for (var i = 0; i < postList.length; i++) {
        const post = postList[i]

        // Change template based on search post type
        switch (post.type) {
            case 'product':
                searchResultEl.append(productTeaserTemplate(post.postUrl, post.image, post.title, post.read_more, post.starImage))
                break;
            case 'ambassador':
                searchResultEl.append(ambassadorTeaserTemplate(post.postUrl, post.image, post.title, post.read_more))
                break;
            default:
                searchResultEl.append(newsTeaserTemplate(post.postUrl, post.image, post.title, post.read_more))
        }
    }

    // Set previous scroll position
    document.documentElement.scrollTop = lastScrollHeight;


    if (isLastPage()) {
        jQuery('.load-more-action-wrap').hide()
    } else {
        jQuery('.load-more-action-wrap').show()
    }
    setPage(state.page + 1)

}

function isLastPage() {
    let isLast = false


    if ((state.posts_per_page * state.page) < state.total_posts) {
        isLast = false
    } else {
        isLast = true
    }
    return isLast
}

function resetSearch(newKeys) {
    searchResultEl.empty()
    setPage(1)
    setKeys(newKeys)
    getSearchPosts()
}

function getSearchPosts() {
    setLoading(true)
    axios
        .post(searchApiUrl, {
            keys: state.keys, page: state.page, posts_per_page: state.posts_per_page,
        })
        .then(function (response) {
            const data = response.data;
            setTotalPost(data.total_posts)
            setPostPerPage(data.posts_per_page)
            setPage(data.page)
            addPosts(data.posts)

        })
        .catch(function (error) {
            // handle error
            // console.log(error);
        })
        .then(function () {
            // always executed
            setTimeout(function () {
                setLoading(false)
            }, 200)
        });
}

searchForm.on('submit', function (e) {
    e.preventDefault()
    let newKeys = searchFormInput.val()
    if (newKeys != state.keys) {
        resetSearch(newKeys)
    }
})


if (searchLoadMoreBtn.length) {

    searchLoadMoreBtn.on('click', getSearchPosts)
    jQuery(document).ready(function () {
        setSearchVelue(state.keys)
        getSearchPosts()
    });
}
